<ng-container *ngIf="positionRowData">
    <button mat-icon-button *ngIf="positionRowData.isExpanded$ | async" (click)="onCollapseRowClick.emit(); $event.stopPropagation()">
        <fa-icon icon="chevron-up"></fa-icon>
    </button>
    <button mat-icon-button class="ml-auto" (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu">
        <fa-icon icon="ellipsis-vertical"></fa-icon>
    </button>
    <mat-menu #menu>
        <ng-template matMenuContent>
            <button mat-menu-item (click)="onAllowanceClick.emit()" [disabled]="_disabled || positionRowData.form?.controls.FixedPrices.getRawValue()">
                <fa-icon class="mat-icon" icon="percent"></fa-icon>
                <span>Rabatte ({{ positionRowData.allowanceCount$ | async }})</span>
            </button>
            <button mat-menu-item (click)="onChargeClick.emit()" [disabled]="_disabled || positionRowData.form?.controls.FixedPrices.getRawValue()">
                <fa-icon class="mat-icon" icon="percent"></fa-icon>
                <span>Zuschläge ({{ positionRowData.chargeCount$ | async }})</span>
            </button>
            <!--                        <button mat-menu-item (click)="onChargeByTypeClick(positionRowData)" [disabled]="_disabled" *ngIf="positionRowData.entity.Type === AccountsReceivableLedgerTypeEnum.Group">-->
            <!--                            <fa-icon class="mat-icon" icon="percent"></fa-icon>-->
            <!--                            <span>spezifische Zuschläge ({{ positionRowData.chargeByTypeCount$ | async }})</span>-->
            <!--                        </button>-->
            <button mat-menu-item (click)="onChargeOverrideClick.emit()" [disabled]="_disabled" *ngIf="positionRowData.entity.Type === AccountsReceivableLedgerTypeEnum.Group && syncCostAmountAndBaseCost === false">
                <fa-icon class="mat-icon" icon="percent"></fa-icon>
                Zuschläge überschreiben ({{ positionRowData.chargeByTypeCount$ | async }})
            </button>
            <button mat-menu-item (click)="onToggleOptional.emit()" [disabled]="_disabled">
                <fa-icon class="mat-icon" icon="signs-post"></fa-icon>
                {{ positionRowData.form?.controls.IsOptional.getRawValue() ? 'optional markierung aufheben' : 'als optional markieren' }}
            </button>
            <button mat-menu-item (click)="onToggleCrossedOut.emit()" [disabled]="_disabled">
                <fa-icon class="mat-icon" icon="slash"></fa-icon>
                {{ positionRowData.form?.controls.CrossedOut.getRawValue() ? 'durchgestrichen aufheben' : 'durchstreichen' }}
            </button>

            <button mat-menu-item (click)="onToggleFixedPrice.emit()" [disabled]="_disabled" *ngIf="isBookingPositionTypeEnum(positionRowData.form?.controls.Type.getRawValue())">
                <fa-icon class="mat-icon" icon="snowflake"></fa-icon>
                {{ positionRowData.form?.controls.FixedPrices.getRawValue() ? 'Gefrorenen Preis aufheben' : 'Preis einfrieren' }}
                <app-hint-icon hint="Eingefrorene Preise weden nicht von Vorbewertungen, Erhöhung/Minderung oder Zuschlägen an Titeln beeinflusst"></app-hint-icon>
            </button>

            <button mat-menu-item (click)="onSplitClick.emit()" [disabled]="_disabled" *ngIf="isBookingPositionTypeEnum(positionRowData.form?.controls.Type.getRawValue()) && positionRowData.form?.controls.childArlsCalculation.length > 0">
                <fa-icon class="mat-icon" icon="arrow-right-from-bracket"></fa-icon>
                Position sprengen
                <app-hint-icon hint="Kalkulierte Positionen werden aus dieser herausgeholt und können als reguläre Positionen verwendet werden"></app-hint-icon>
            </button>

            <button  mat-menu-item (click)="onMoveClick.emit()" [disabled]="_disabled || disableMove">
                <fa-icon class="mat-icon"  icon="arrows-up-down"></fa-icon>
                <span>Position verschieben</span>
            </button>
            <button  mat-menu-item (click)="onCopyClick.emit()" [disabled]="_disabled">
                <fa-icon class="mat-icon"  icon="money-bill"></fa-icon>
                <span>Position kopieren</span>
            </button>
            <button mat-menu-item (click)="onToggleStartOnNewPage.emit()" [disabled]="_disabled" *ngIf="!!positionRowData.form?.value.StartOnNewPage">
                <fa-icon class="mat-icon" icon="slash" mask="file-arrow-down"></fa-icon>
                Neue Seite aufheben
            </button>
            <button mat-menu-item (click)="onToggleStartOnNewPage.emit()" [disabled]="_disabled"  *ngIf="!positionRowData.form?.value.StartOnNewPage">
                <fa-icon class="mat-icon" icon="file-arrow-down"></fa-icon>
                <span>Neue Seite</span>
            </button>
            <button mat-menu-item (click)="onDeleteClick.emit()" [disabled]="_disabled" class="app-foreground-warn">
                <fa-icon class="mat-icon" icon="trash"></fa-icon>
                <span>löschen</span>
            </button>
        </ng-template>
    </mat-menu>
</ng-container>
